export default __webpack_public_path__ + "video_m1fe7b7.jpg";